/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Crosspostingcrosspublished2Inputs */

const en_crosspostingcrosspublished2 = /** @type {(inputs: Crosspostingcrosspublished2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Published to ${i?.count} accounts.`)
};

const de_crosspostingcrosspublished2 = /** @type {(inputs: Crosspostingcrosspublished2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auf ${i?.count} Konten veröffentlicht.`)
};

/**
* | output |
* | --- |
* | "Published to {count} accounts." |
*
* @param {Crosspostingcrosspublished2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingcrosspublished2 = /** @type {((inputs: Crosspostingcrosspublished2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingcrosspublished2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingcrosspublished2(inputs)
	return de_crosspostingcrosspublished2(inputs)
});
export { crosspostingcrosspublished2 as "crosspostingCrossPublished" }